import { createFileRoute } from "@tanstack/react-router";
import { ClinicalPageShell } from "@/components/clinical";
import { DashboardCard, CrudShellHeader, MERCHANT_HUB_GRID } from "@/components/ds";
import { getCatalogacionHubLinks } from "@/lib/workspace-hubs";
import { useTenantProductFlags } from "@/hooks/use-tenant-product-flags";
import { useTenantContext } from "@/lib/tenant-context";
import { businessAllowsMerchantPersonalization } from "@/lib/business-profile";
import { MerchantExperienceBar } from "@/components/renata/MerchantExperienceBar";

export const Route = createFileRoute("/app/catalogacion/")({
  component: CatalogacionHubPage,
  head: () => ({ meta: [{ title: "Catalogación — Structura Market" }] }),
});

function CatalogacionHubPage() {
  const productFlags = useTenantProductFlags();
  const { businessProfile } = useTenantContext();
  const merchantEnabled =
    productFlags?.integrations_merchant === true &&
    businessAllowsMerchantPersonalization(businessProfile);
  const priceListsEnabled = productFlags?.price_lists === true;
  const shelfLabelsEnabled = productFlags?.shelf_labels === true;
  const links = getCatalogacionHubLinks(merchantEnabled, businessProfile, priceListsEnabled, shelfLabelsEnabled);

  return (
    <div>
      <CrudShellHeader title="Catalogación" description="Productos, categorías, combos y packs" />
      <ClinicalPageShell offset="none" className="pt-6">
        <MerchantExperienceBar screenId="catalogacion" />
        <div className="mb-4">
          <p className="text-sm font-semibold text-foreground">¿Qué querés gestionar?</p>
          <p className="text-xs text-muted-foreground">Elegí un módulo del catálogo</p>
        </div>
        <div className={MERCHANT_HUB_GRID} data-tour="workspace-hub">
          {links.map((link) => (
            <DashboardCard
              key={link.id}
              to={link.href}
              search={link.search}
              icon={link.icon}
              title={link.label}
              subtitle={link.description ?? ""}
            />
          ))}
        </div>
      </ClinicalPageShell>
    </div>
  );
}
